var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ai-custom-page-detail" },
    [
      _c("div", { staticClass: "detail-header" }, [
        _c(
          "div",
          { staticClass: "header-left" },
          [
            _c(
              "el-button",
              { attrs: { type: "text" }, on: { click: _vm.handleGoBack } },
              [_c("i", { staticClass: "el-icon-arrow-left" })]
            ),
            _c("span", { staticClass: "form-name" }, [
              _vm._v(_vm._s(_vm.formConfig.name))
            ]),
            _vm.currentRevision !== null
              ? _c(
                  "span",
                  {
                    staticStyle: {
                      "font-size": "12px",
                      color: "#909399",
                      "margin-left": "8px"
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("CargoMsg.Cargo_VersionNo")) +
                        ": " +
                        _vm._s(_vm.currentRevision)
                    )
                  ]
                )
              : _vm._e()
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "header-right" },
          [
            _c("span", { staticClass: "last-operate-time" }, [
              _vm._v(
                _vm._s(_vm.$t("CargoMsg.Cargo_LastOperateTime")) +
                  ": " +
                  _vm._s(_vm.lastOperateTime)
              )
            ]),
            _c(
              "el-button",
              {
                staticClass: "revision-toggle",
                attrs: { type: "text" },
                on: { click: _vm.handleRevisionPanelToggle }
              },
              [_c("i", { staticClass: "el-icon-time" })]
            ),
            _vm.formConfig.published === _vm.PUBLISHED.DRAFT.value
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "warning", size: "small" },
                    on: { click: _vm.handleSaveDraft }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_SaveDraft")))]
                )
              : _vm._e(),
            _c(
              "el-button",
              {
                attrs: { type: "primary", size: "small" },
                on: { click: _vm.handlePublish }
              },
              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Publish")))]
            ),
            _c(
              "el-button",
              { attrs: { size: "small" }, on: { click: _vm.handleGoBack } },
              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Close")))]
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "detail-content" }, [
        _c(
          "div",
          {
            staticClass: "section",
            staticStyle: {
              height: "100%",
              padding: "0 5px",
              display: "flex",
              "flex-direction": "row",
              position: "relative"
            }
          },
          [
            _c("transition", { attrs: { name: "slide" } }, [
              _vm.revisionVisible
                ? _c(
                    "div",
                    { staticClass: "revisions-panel" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "revision-item current",
                          class: { selected: _vm.currentRevision === null },
                          on: { click: _vm.handleCurrentFormClick }
                        },
                        [
                          _c("div", { staticClass: "dot" }),
                          _c("div", { staticClass: "revision-info" }, [
                            _c("div", { staticClass: "revision-title" }, [
                              _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Current")))
                            ])
                          ])
                        ]
                      ),
                      _vm._l(_vm.revisionList, function(revision) {
                        return _c(
                          "div",
                          {
                            key: revision.serialNumber,
                            staticClass: "revision-item",
                            class: {
                              selected:
                                revision.serialNumber === _vm.currentRevision
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleRevisionClick(revision)
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "dot" }),
                            _c("div", { staticClass: "revision-info" }, [
                              _c("div", { staticClass: "revision-title" }, [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      background: "#f5f7fa",
                                      padding: "2px 4px",
                                      "border-radius": "2px"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          revision.formConfig.published ===
                                            _vm.PUBLISHED.PUBLISHED.value
                                            ? _vm.$t("CargoMsg.Cargo_Published")
                                            : _vm.$t("CargoMsg.Cargo_Draft")
                                        ) +
                                        " "
                                    )
                                  ]
                                ),
                                _c(
                                  "span",
                                  { staticStyle: { "margin-left": "8px" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        new Date(
                                          revision.formConfig.dateModified
                                        ).toLocaleString()
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _c("div", { staticClass: "revision-version" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_VersionNo")) +
                                    ": " +
                                    _vm._s(revision.serialNumber)
                                )
                              ]),
                              _c(
                                "a",
                                {
                                  staticClass: "revision-preview",
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.handleRevisionPreview(revision)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_PreviewRevision")
                                    )
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      }),
                      _vm.currentRevision !== null
                        ? _c(
                            "el-button",
                            {
                              staticStyle: {
                                position: "sticky",
                                bottom: "10px",
                                left: "50%",
                                transform: "translateX(-50%)",
                                width: "50%",
                                "z-index": "1000"
                              },
                              attrs: { type: "primary" },
                              on: { click: _vm.handleRestoreRevision }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_RestoreRevision")
                                  ) +
                                  " "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e()
            ]),
            _c(
              "div",
              {
                staticClass: "left-tree",
                staticStyle: {
                  flex: "0 0 auto",
                  width: "200px",
                  margin: "5px 0",
                  height: "calc(100vh - 180px)",
                  overflow: "hidden",
                  display: "flex",
                  "flex-direction": "column"
                }
              },
              [
                _c("cargo-ag-grid", {
                  staticStyle: { flex: "1" },
                  attrs: {
                    "grid-options": _vm.leftGridOptions,
                    "row-data": _vm.leftFinalRowData,
                    "show-side-bar": false
                  }
                })
              ],
              1
            ),
            _c("div", {
              staticStyle: {
                flex: "0 0 auto",
                width: "2px",
                margin: "0 5px",
                background: "#DCDFE6"
              }
            }),
            _c(
              "div",
              {
                staticClass: "middle-tree",
                staticStyle: {
                  flex: "0 0 auto",
                  width: "300px",
                  margin: "5px 0",
                  height: "calc(100vh - 180px)",
                  overflow: "hidden",
                  display: "flex",
                  "flex-direction": "column"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "search-box",
                    staticStyle: { padding: "10px" }
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        placeholder: _vm.$t("CargoMsg.Cargo_Search"),
                        "prefix-icon": "el-icon-search",
                        clearable: ""
                      },
                      on: { input: _vm.handleSearch },
                      model: {
                        value: _vm.searchKeyword,
                        callback: function($$v) {
                          _vm.searchKeyword = $$v
                        },
                        expression: "searchKeyword"
                      }
                    })
                  ],
                  1
                ),
                _c("el-tree", {
                  ref: "middleTree",
                  staticStyle: { flex: "1", overflow: "auto" },
                  attrs: {
                    data: _vm.middleTreeData,
                    props: _vm.middleTreeProps,
                    "node-key": "id",
                    "default-expand-all": "",
                    "expand-on-click-node": false,
                    "show-checkbox": "",
                    "filter-node-method": _vm.filterNode
                  },
                  on: { check: _vm.handleTreeCheck },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(ref) {
                        var node = ref.node
                        var data = ref.data
                        return _c("span", { staticClass: "custom-tree-node" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.getLocalizedName(data)))
                          ])
                        ])
                      }
                    }
                  ])
                })
              ],
              1
            ),
            _c("div", {
              staticStyle: {
                flex: "0 0 auto",
                width: "2px",
                margin: "0 5px",
                background: "#DCDFE6"
              }
            }),
            _c(
              "div",
              {
                staticClass: "add-controls",
                staticStyle: {
                  flex: "0 0 auto",
                  width: "200px",
                  margin: "5px 0",
                  height: "calc(100vh - 180px)",
                  display: "flex",
                  "flex-direction": "column",
                  "justify-content": "center",
                  "align-items": "center",
                  background: "#fff"
                }
              },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { width: "160px", "margin-bottom": "20px" },
                    attrs: {
                      type: "primary",
                      disabled:
                        _vm.isRevision ||
                        !_vm.selectedPagePartId ||
                        !_vm.hasSelectedElements
                    },
                    on: { click: _vm.handleAddSelectedElements }
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("CargoMsg.Cargo_AddSelectedElements")) +
                        " "
                    )
                  ]
                ),
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "160px" },
                    attrs: {
                      placeholder: _vm.$t("CargoMsg.Cargo_SelectPagePart")
                    },
                    model: {
                      value: _vm.selectedPagePartId,
                      callback: function($$v) {
                        _vm.selectedPagePartId = $$v
                      },
                      expression: "selectedPagePartId"
                    }
                  },
                  _vm._l(_vm.localizedPagePartOptions, function(option) {
                    return _c("el-option", {
                      key: option.key,
                      attrs: { label: option.label, value: option.value }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _c("div", {
              staticStyle: {
                flex: "0 0 auto",
                width: "2px",
                margin: "0 5px",
                background: "#DCDFE6"
              }
            }),
            _c(
              "div",
              {
                staticClass: "debug-and-config-container",
                staticStyle: {
                  flex: "1",
                  margin: "5px 0",
                  height: "calc(100vh - 180px)",
                  overflow: "hidden",
                  background: "#fff"
                }
              },
              [
                _c("div", { staticClass: "config-header" }, [
                  _c("span", { staticClass: "config-title" }, [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DebugAndConfig")))
                  ]),
                  _c(
                    "div",
                    { staticClass: "config-actions" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleAddPagePart }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("CargoMsg.Cargo_AddPagePart")) +
                              " "
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleFormConfig }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("CargoMsg.Cargo_ConfigForm")) +
                              " "
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handlePreview }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("CargoMsg.Cargo_Debug")) + " "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _c(
                  "el-tabs",
                  {
                    staticStyle: { height: "calc(100% - 50px)" },
                    attrs: { type: "border-card" },
                    model: {
                      value: _vm.activeTab,
                      callback: function($$v) {
                        _vm.activeTab = $$v
                      },
                      expression: "activeTab"
                    }
                  },
                  [
                    _c(
                      "el-tab-pane",
                      {
                        staticStyle: { height: "100%" },
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_VisualizationView"),
                          name: "visualization"
                        }
                      },
                      [
                        _c("ai-custom-page-visualization-view", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.activeTab === "visualization",
                              expression: "activeTab === 'visualization'"
                            }
                          ],
                          ref: "visualizationView",
                          staticStyle: { height: "100%" },
                          attrs: {
                            "page-parts": _vm.pageParts,
                            "is-revision": _vm.isRevision,
                            "application-scene":
                              _vm.formConfig.applicationScene,
                            "business-type": _vm.formConfig.businessType
                          },
                          on: {
                            "update:pageParts": _vm.handlePagePartsUpdate,
                            "remove-page-part": _vm.removePagePart,
                            "remove-element": _vm.removeElement
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-tab-pane",
                      {
                        staticStyle: { height: "100%" },
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_CodeView"),
                          name: "code"
                        }
                      },
                      [
                        _c("ai-custom-page-code-view", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.activeTab === "code",
                              expression: "activeTab === 'code'"
                            }
                          ],
                          ref: "codeView",
                          staticStyle: { height: "100%" },
                          attrs: {
                            "page-parts": _vm.pageParts,
                            "form-config": _vm.formConfig,
                            "form-data": _vm.formData,
                            visible:
                              _vm.activeTab === "code" || _vm.updateFormCode,
                            "is-revision": _vm.isRevision
                          },
                          on: { "update:formCode": _vm.handleFormCodeUpdate }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-tab-pane",
                      {
                        staticStyle: { height: "100%" },
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_ChatView"),
                          name: "chat"
                        }
                      },
                      [
                        _c("ai-custom-page-chat-view", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.activeTab === "chat",
                              expression: "activeTab === 'chat'"
                            }
                          ],
                          ref: "chatView",
                          staticStyle: { height: "100%" },
                          attrs: {
                            "page-parts": _vm.pageParts,
                            "is-revision": _vm.isRevision,
                            "form-uuid": _vm.formUuid
                          },
                          on: { ruleChange: _vm.handleRuleChange }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "el-dialog",
        {
          staticClass: "preview-dialog-wrapper",
          attrs: {
            visible: _vm.previewDialog.visible,
            title: _vm.$t("CargoMsg.Cargo_Debug"),
            fullscreen: false,
            "show-close": true,
            "close-on-click-modal": true,
            "close-on-press-escape": false,
            "custom-class": "preview-dialog",
            modal: true,
            "append-to-body": true,
            "modal-append-to-body": true,
            width: "70%",
            top: "20px"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.previewDialog, "visible", $event)
            }
          }
        },
        [
          _vm.previewDialog.visible
            ? _c("ai-custom-page-data-view", {
                attrs: {
                  "page-parts": _vm.pageParts,
                  "form-config": _vm.formConfig,
                  "form-data": _vm.formData,
                  debug: true,
                  readonly: false,
                  "is-revision": _vm.isRevision
                },
                on: {
                  close: function($event) {
                    _vm.previewDialog.visible = false
                  },
                  "update:formData": _vm.handleFormDataUpdate
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c("ai-custom-page-form-config", {
        attrs: {
          visible: _vm.formConfigVisible,
          "form-config": _vm.formConfig,
          "is-create-mode": !_vm.formUuid
        },
        on: {
          "update:visible": function($event) {
            _vm.formConfigVisible = $event
          },
          confirm: _vm.handleFormConfigConfirm,
          cancel: _vm.handleFormConfigCancel
        }
      }),
      _vm.pagePartConfigVisible
        ? _c("ai-custom-page-page-part-config", {
            attrs: {
              visible: _vm.pagePartConfigVisible,
              "business-type": _vm.formConfig.businessType,
              "page-part": _vm.currentPagePart,
              "is-create-page-part": _vm.isCreatePagePart,
              "application-scene": _vm.formConfig.applicationScene
            },
            on: {
              "update:visible": function($event) {
                _vm.pagePartConfigVisible = $event
              },
              confirm: _vm.handlePagePartConfigConfirm,
              "remove-page-part": _vm.removePagePart
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }